var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import staging_seekpass_co from '../../../config/dev/staging_seekpass_co.js';
import seekpass_co from '../../../config/prod/seekpass_co.js';
export var stagingConfigs = [staging_seekpass_co];
export var prodConfigs = [seekpass_co];
export var mappings = (function () {
    var devConfigs = {
        'seekpass-local.com': staging_seekpass_co,
    };
    var result = __assign({}, devConfigs);
    var configs = __spreadArray(__spreadArray([], stagingConfigs, true), prodConfigs, true);
    for (var _i = 0, configs_1 = configs; _i < configs_1.length; _i++) {
        var config = configs_1[_i];
        result[config.clientDomain] = config;
    }
    return result;
})();
export default (function (_a) {
    var _b;
    var host = _a.host;
    var defaultConfig = staging_seekpass_co;
    var hostName = host ? host.split(':')[0] : host;
    if (typeof hostName === 'undefined') {
        return defaultConfig;
    }
    return (_b = mappings[hostName]) !== null && _b !== void 0 ? _b : defaultConfig;
});
//# sourceMappingURL=seekpass.js.map